export const BRAND = {
  MMTAX: 1,
  PRO_TAX_CONSULTING: 2,
};

const _BRAND_DESCRIPTION_MAP = {};
_BRAND_DESCRIPTION_MAP[BRAND.MMTAX] = 'M & M Tax Service';
_BRAND_DESCRIPTION_MAP[BRAND.PRO_TAX_CONSULTING] = 'Pro Tax Consulting';

export const BRAND_DESCRIPTION_MAP = _BRAND_DESCRIPTION_MAP;

export default {
  BRAND,
  BRAND_DESCRIPTION_MAP,
};
